interface ShopNavigationStore {
  getters: Record<string, unknown>;
  dispatch: (type: string, payload?: unknown) => Promise<unknown> | unknown;
}

type NavigationWarningLogger = (message: string, error: unknown) => void;

export const ensureShopInfoForNavigation = async (
  store: ShopNavigationStore,
  warn: NavigationWarningLogger = console.warn
): Promise<void> => {
  if (!store.getters['shop/currentShopId']) {
    return;
  }

  if (!store.getters['shop/hasCurrentShopInfo']) {
    await store.dispatch('shop/fetchInfo');
    return;
  }

  if (store.getters['shop/isInfoRefreshDue']) {
    try {
      Promise.resolve(store.dispatch('shop/fetchInfo', { silent: true })).catch((error) => {
        warn('Erreur shop/fetchInfo en arrière-plan', error);
      });
    } catch (error) {
      warn('Erreur shop/fetchInfo en arrière-plan', error);
    }
  }
};

export const isCurrentShopKnownIncomplete = (getters: Record<string, unknown>): boolean => (
  getters['shop/hasCurrentShopInfo'] === true && getters['shop/isComplete'] !== true
);
